export default "__VITE_ASSET__MGZdEghv__"